<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
<div class="card" >
    <div class="card-header bg-primary text-left text-white font-weight-bold">
      Upload Consumable Target
    </div>
    <div class="card-body mat-card">
<div class="row">
  <div class="col-sm-6">
    <div class="form-group row text-left pl-2">
      <label for="lblPoRefNo" class="col-sm-4 col-form-label">Group
        <span class="font-red-flamingo">*</span></label>
      <div class="col-sm-8">
        <mat-radio-group aria-label="Select Group" [(ngModel)]="SelectedGroupId">
            
            <mat-radio-button *ngFor="let item of ProductGroupList; let i = index;" value={{item.ProductGroupId}} class="pr-1">
              {{item.ProductGroupDesc}}
            </mat-radio-button>
            <!-- <mat-radio-button value="Consumable">Consumable</mat-radio-button> -->

          </mat-radio-group>
          
      </div>
      
    </div>
  </div>
</div>



        <div class="row">
            <div class="col-sm-6">

                <mat-card>
                    <mat-card-title class="font-weight-bold caption-color">Download Existing</mat-card-title>
                    <mat-divider></mat-divider>
                    <mat-card-content class="pt-2">
                
                        <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group row text-left">
                                <label for="lblChoosefile" class="col-sm-4 col-form-label">Fiscal<span class="font-red-flamingo">*</span></label>
                                    <div class="col-sm-8">
                                    <div class="input-group">
                                        <select id="ddlFiscal" name="ddlFiscal"  [(ngModel)]="Fiscal" class="form-control">
                              <option *ngFor="let fs of Fiscals" value={{fs.Fiscal}}>{{fs.Fiscal }} </option>
                            </select>
                                      </div>
                                    </div>
                               
                              </div>
                            </div>
                            
                          </div>
                
                          <br>
                          <mat-divider></mat-divider>
                          <br>
                          <div class="row">
                                  <div class="col-sm-4"></div>
                                  <div class="col-sm-8">
                                  <button type="button" class="btn btn-primary" (click)="DownloadConsumableTarget()" >Download</button>
                              
                            </div>
                          </div>
                    </mat-card-content>
                    </mat-card>
            </div>
            <div class="col-sm-6">
                <mat-card>
                    <mat-card-title class="font-weight-bold caption-color">Upload Target</mat-card-title>
                    <mat-divider></mat-divider>
                    <mat-card-content class="pt-2">
     
                        <div class="row">
                            <div class="col-sm-12">
                              <div class="form-group row text-left">
                                <label for="lblChoosefile" class="col-sm-4 col-form-label">Choose file<span
                                    class="font-red-flamingo">*</span></label>
                                    <div class="col-sm-8">
                                    <div class="input-group">
                                        <div class="custom-file">
                                            <input type="file" #file placeholder="Choose file" class="custom-file-input" (change)="changePP($event)"  name="inputGroupFile01" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" >
                                          <label class="custom-file-label" for="inputGroupFile01">{{selectedPPFileName}}</label>
                                        </div>
                                      </div>
                                    </div>
                               
                              </div>
                            </div>
                            
                          </div>
                          <br>
                          <mat-divider></mat-divider>
                          <br>
                          <div class="row">
                                  <div class="col-sm-4"></div>
                                  <div class="col-sm-8">
                                  <button type="button" [disabled]="Enable" class="btn btn-primary" (click)="UploadConsumableTarget(file.files)" >Upload</button>
                              
                            </div>
                          </div>
                    </mat-card-content>
                    </mat-card>
            </div>
        </div>

        <!-- <div class="row">
          <div class="col-sm-6">
        
          </div>
          <mat-spinner mode="indeterminate" diameter="40" *ngIf="showSpinner"></mat-spinner>
     
       
      </div> -->
    